// extracted by mini-css-extract-plugin
export default {"right_article":"index_right_article_qOzoR","first_item":"index_first_item_oNnkX","item":"index_item_b7iAO","check_more":"index_check_more_gD215","assess":"index_assess_RoUOh"};